;(() => {
  if (customElements.get('component-store-overview')) {
    return
  }

  class ComponentStoreOverview extends HTMLElement {
    constructor() {
      super()

      this.initSliderHandler = this.initSlider.bind(this)
    }

    connectedCallback() {
      this.initSliderHandler()
    }

    initSlider() {
      const sliders = this.querySelectorAll('.js-store-slider')
      if (!sliders) {
        return
      }

      sliders.forEach((slider) => {
        new Splide(slider, {
          pagination: true,
          drag: true,
          rewind: true,
          autoplay: false,
          arrows: false,
          classes: {
            arrows: 'splide__arrows',
            arrow: 'splide__arrow',
            prev: 'splide__arrow--prev',
            next: 'splide__arrow--next',
          },
        }).mount()
      })
    }
  }

  customElements.define('component-store-overview', ComponentStoreOverview)
})()
